import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { ISortingState } from './sorting.reducer';
import * as fromReducer from './sorting.reducer';

const getSortingState = createFeatureSelector<ISortingState>('sortings');

export const getDocumentSorting = createSelector(getSortingState, fromReducer.getDocumentSorting);
export const getDocumentSortingActionState = createSelector(
  getSortingState,
  fromReducer.getDocumentSortingActionState
);

export const getTicketSorting = createSelector(getSortingState, fromReducer.getTicketSorting);
export const getTicketSortingActionState = createSelector(
  getSortingState,
  fromReducer.getTicketSortingActionState
);
